import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useArgusAuth } from "../../hooks/useArgusAuth";
import { useMediaQuery } from "react-responsive";
import useSystemHook from "./../../hooks/SystemHook";
import MobileSiteTopbar from "./MobileSiteTopbar";
import DesktopSiteTopbar from "./DesktopSiteTopbar";
import { COLORS } from "../../constants";

const SiteTopBar = ({
  openSavedVehiclesModal,
  totalGarageItems,
  gotoLoginPage,
  gotoRegistrationPage,
  tecfinityAccountNumber,
  tecfinityAccountName,
  tecfinityAvailableCredit,
  accountType,
  performLogout,
}) => {
  const { user, isLoading, isAuthenticated } = useArgusAuth();
  const [accountMenuAnchor, setAccountMenuAnchor] = useState(null);
  const [openOperatingTimesModal, setOpenOperatingTimesModal] = useState(false);

  const { isMobile, isTablet, isDesktop } = useSystemHook();

  const handleAccountMenuClick = (event) => {
    setAccountMenuAnchor(event.currentTarget);
  };

  const handleAccountMenuClose = () => {
    setAccountMenuAnchor(null);
  };

  const handleOpenOperatingTimesModal = () => {
    setOpenOperatingTimesModal(true);
  };

  const handleCloseOperatingTimesModal = () => {
    setOpenOperatingTimesModal(false);
  };

  if (isLoading) return null;

  return (
    <>
      {isMobile === true && (
        <MobileSiteTopbar isAuthenticated={isAuthenticated} user={user} />
      )}

      {!isMobile && (
        <DesktopSiteTopbar
          openSavedVehiclesModal={openSavedVehiclesModal}
          totalGarageItems={totalGarageItems}
          gotoLoginPage={gotoLoginPage}
          gotoRegistrationPage={gotoRegistrationPage}
          tecfinityAccountNumber={tecfinityAccountNumber}
          tecfinityAccountName={tecfinityAccountName}
          tecfinityAvailableCredit={tecfinityAvailableCredit}
          accountType={accountType}
          performLogout={performLogout}
          isAuthenticated={isAuthenticated}
          accountMenuAnchor={accountMenuAnchor}
          handleAccountMenuClick={handleAccountMenuClick}
          handleAccountMenuClose={handleAccountMenuClose}
        />
      )}

      <Dialog
        open={openOperatingTimesModal}
        onClose={handleCloseOperatingTimesModal}
        maxWidth="md"
        fullWidth
      >
        <DialogContent sx={{ p: 1, position: "relative" }}>
          <IconButton
            onClick={handleCloseOperatingTimesModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              zIndex: 1,
              backgroundColor: "#fff",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box
            component="img"
            src="/images/AprilTrading.jpeg"
            alt="Operating times"
            sx={{
              width: "100%",
              height: "auto",
              display: "block",
              borderRadius: 1,
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SiteTopBar;
